import { useLocation } from "@tanstack/react-router";
import { PostHogProvider } from "posthog-js/react";
import { useEffect, type PropsWithChildren } from "react";

import { posthog } from "@/utils/posthog";

export const AnalyticsProvider = ({ children }: PropsWithChildren) => {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
};

export default AnalyticsProvider;

export const AnalyticsRouterTracker = () => {
  const location = useLocation();
  useEffect(() => {
    posthog.capture("$pageview");
    // oxlint-disable-next-line react/exhaustive-effect-dependencies
  }, [location]);

  return null;
};
